<template>
  <div>
    <PayrollOverviewsActions :title="title" @filter="isBeingFiltered = $event.isBeingFiltered" />
    <payroll-overviews-generation-form @generate="generatePayrollOverview($event)" />
    <update-modal v-if="payrollOverviewsGenerationLoading">
      <template v-slot:modalData>
        <vue-simple-spinner size="massive" />
      </template>
    </update-modal>
    <tol-table
      :table-data="payrollOverviews"
      :columns="columns"
      :show-spinner="isLoading"
      :is-row-clickable="true"
      @row-click="onRowClick($event)"
    >
      <template v-slot:tableHeader>
        <th-sortable
          :direction="currentSortField === 'created_at' ? currentSortDirection : 'none'"
          field-name="created_at"
          @change="onSortOrderChange"
          >{{ $t('payrollOverviews.listing.labels.created_at') }}</th-sortable
        >
        <th>{{ $t('payrollOverviews.listing.labels.created_by_name') }}</th>
        <th-sortable
          :direction="currentSortField === 'range_start' ? currentSortDirection : 'none'"
          field-name="range_start"
          @change="onSortOrderChange"
          >{{ $t('payrollOverviews.listing.labels.range_start') }}
        </th-sortable>
        <th-sortable
          :direction="currentSortField === 'range_end' ? currentSortDirection : 'none'"
          field-name="range_end"
          @change="onSortOrderChange"
          >{{ $t('payrollOverviews.listing.labels.range_end') }}
        </th-sortable>
        <th>{{ $t('payrollOverviews.listing.labels.departments') }}</th>
        <th-sortable
          :direction="currentSortField === 'pay_period_type' ? currentSortDirection : 'none'"
          field-name="pay_period_type"
          @change="onSortOrderChange"
          >{{ $t('payrollOverviews.listing.labels.pay_period') }}
        </th-sortable>

        <th-sortable
          :direction="currentSortField === 'status' ? currentSortDirection : 'none'"
          field-name="status"
          @change="onSortOrderChange"
          >{{ $t('payrollOverviews.listing.labels.status') }}
        </th-sortable>
      </template>
      <template v-slot:created_at="{ value }">
        {{ formatDateWithTime(value.created_at) }}
      </template>

      <template v-slot:range_start="{ value }">
        <font-awesome-icon icon="calendar-alt" />
        {{ formatDate(value.range_start) }}
      </template>
      <template v-slot:range_end="{ value }">
        <font-awesome-icon icon="calendar-alt" />
        {{ formatDate(value.range_end) }}
      </template>
    </tol-table>
    <Pagination
      :records-per-page="listPerPage"
      :offset="currentPage"
      :record-count="recordCount"
      @change="onChangePaginationParams($event)"
    />
  </div>
</template>
<script>
import TolTable from '../../../../components/TolTable';
import ThSortable from '../../../../components/ThSortable';
import Pagination from '../../../../components/Pagination';
import PayrollOverviewsActions from './components/PayrollOverviewsActions.vue';
import {
  PayrollOverviewsListingGetters,
  PayrollOverviewsListingActions
} from './payroll-overviews-listing.keys';
import { AppActions } from '@/app/app.keys';
import format from 'date-fns/format';
import PayrollOverviewsGenerationForm from './components/PayrollOverviewsGenerationForm.vue';
import UpdateModal from '@/app/components/UpdateModal';
export default {
  name: 'PayrollOverviewsListing',
  components: {
    TolTable,
    UpdateModal,
    ThSortable,
    Pagination,
    PayrollOverviewsActions,
    PayrollOverviewsGenerationForm
  },
  data() {
    return {
      isBeingFiltered: false
    };
  },
  computed: {
    payrollOverviewsGenerationLoading() {
      return this.$store.getters[PayrollOverviewsListingGetters.PayrollOverviewsGenerationLoading];
    },
    title() {
      return 'payrollOverviews.listing.actions.titleAll';
    },
    isLoading() {
      return (
        this.$store.getters[PayrollOverviewsListingGetters.PayrollOverviewsIsLoading] ||
        this.isBeingFiltered
      );
    },
    payrollOverviews() {
      return this.$store.getters[PayrollOverviewsListingGetters.PayrollOverviews];
    },
    columns() {
      return [
        'created_at',
        'created_by_name',
        'range_start',
        'range_end',
        'department_names',
        'pay_period_type',
        'status'
      ];
    },
    currentSortField() {
      return this.$store.getters[PayrollOverviewsListingGetters.PayrollOverviewsSortBy];
    },
    currentSortDirection() {
      return this.$store.getters[PayrollOverviewsListingGetters.PayrollOverviewsSortDirection];
    },
    listPerPage() {
      return this.$store.getters[PayrollOverviewsListingGetters.PayrollOverviewsPerPage];
    },
    currentPage() {
      return this.$store.getters[PayrollOverviewsListingGetters.PayrollOverviewsListingOffset];
    },
    recordCount() {
      return this.$store.getters[PayrollOverviewsListingGetters.PayrollOverviewsCount];
    },
    tolAlert() {
      return false;
    },
    poGenerateMessage() {
      const count = this.$store.getters[PayrollOverviewsListingGetters.ProcessedTimeSheetCount];
      return `Please wait. Processing time sheets: ${count}`;
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('payrollOverviews.listing.title'));
    this.$store.dispatch(PayrollOverviewsListingActions.RetrievePayrollOverviews);
  },
  methods: {
    onSortOrderChange(sortOrder) {
      this.$store.dispatch(PayrollOverviewsListingActions.SetPayrollOverviewsSortOrder, sortOrder);
    },
    onChangePaginationParams(evt) {
      this.$store.dispatch(
        PayrollOverviewsListingActions.SetPayrollOverviewsPaginationParameters,
        evt
      );
    },
    formatDate(d) {
      return d ? format(d, 'YYYY-MM-DD') : null;
    },
    formatDateWithTime(d) {
      return d ? format(d, 'YYYY-MM-DD HH:mm') : null;
    },
    generatePayrollOverview(evt) {
      this.$store.dispatch(PayrollOverviewsListingActions.GeneratePayrollOverview, evt);
    },
    onRowClick(evt) {
      this.$router.push(`/payroll-overviews/${evt.reference_number}`);
    }
  }
};
</script>

<style lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.red {
  width: 100%;
  height: 100%;
  background-color: $mid-red;
}
.green {
  width: 100%;
  height: 100%;
  background-color: $secondary-green;
}
.yellow {
  width: 100%;
  height: 100%;
  background-color: $primary-warn;
}
</style>
